import React from 'react';
import { ArrowRightIcon, BatteryChargingIcon, PackageIcon, ClockIcon, WeightIcon } from 'lucide-react';
import { Button } from '../ui/Button';
import { useTranslation } from '../../lib/i18n';
interface HeroProps {
  onRequestQuote: () => void;
}
export function Hero({
  onRequestQuote
}: HeroProps) {
  const {
    t
  } = useTranslation();
  return <section className="relative min-h-[580px] md:min-h-[780px] flex items-center bg-dark-bg" data-id="element-190">
      <div className="absolute inset-0 overflow-hidden" data-id="element-191">
        <video autoPlay loop muted playsInline className="absolute inset-0 w-full h-full object-cover" data-id="element-192">
          <source src="https://cdn.magicpatterns.com/uploads/szwwdiBXCG3exkg6vKfMeS/POZADINA.mp4" type="video/mp4" data-id="element-193" />
        </video>
        <div className="absolute inset-0 bg-black/65" data-id="element-194" />
      </div>
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-32" data-id="element-195">
        <div className="max-w-3xl" data-id="element-196">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-white leading-tight mb-12 md:mb-16" data-id="element-197">
            {t.hero.title}
            <br data-id="element-198" />
            <span className="text-brand-yellow" data-id="element-199">{t.hero.titleHighlight}</span>
          </h1>

          <div className="flex flex-col sm:flex-row gap-3 md:gap-4 mb-14 md:mb-20" data-id="element-200">
            <Button variant="primary" size="lg" className="w-full sm:w-auto" onClick={() => document.getElementById('products')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-201">
              {t.hero.btnProducts}
              <ArrowRightIcon className="w-5 h-5 ml-2 inline" data-id="element-202" />
            </Button>
            <Button variant="outline" size="lg" className="w-full sm:w-auto" onClick={onRequestQuote} data-id="element-203">
              {t.hero.btnQuote}
            </Button>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4" data-id="element-204">
            {[{
            icon: <WeightIcon className="w-7 h-7 text-brand-yellow flex-shrink-0" data-id="element-205" />,
            value: 'do 200 kg',
            label: t.hero.capacity
          }, {
            icon: <BatteryChargingIcon className="w-7 h-7 text-brand-yellow flex-shrink-0" data-id="element-206" />,
            value: '48V 36Ah',
            label: t.hero.battery
          }, {
            icon: <ClockIcon className="w-7 h-7 text-brand-yellow flex-shrink-0" data-id="element-207" />,
            value: t.hero.runtimeValue,
            label: t.hero.runtime
          }, {
            icon: <PackageIcon className="w-7 h-7 text-brand-yellow flex-shrink-0" data-id="element-208" />,
            value: t.hero.deliveryValue,
            label: t.hero.delivery
          }].map((item, i) => <div key={i} className="flex items-center space-x-3 bg-dark-surface bg-opacity-80 border border-dark-border rounded-industrial p-3 md:p-4" data-id="element-209">
                {item.icon}
                <div data-id="element-210">
                  <div className="text-base font-bold text-white" data-id="element-211">
                    {item.value}
                  </div>
                  <div className="text-xs text-gray-400" data-id="element-212">{item.label}</div>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}